import Usuario from "model/administracao/cadastro/Usuario";

export default class MetaPorUsuarioRelatorioFilters {
    usuario: Usuario | null;
    inicioPeriodo: Date | null;
    fimPeriodo: Date | null;

    constructor(
        usuario: Usuario | null = null, 
        inicioPeriodo: Date | null = null, 
        fimPeriodo: Date | null = null
    ) {
        this.usuario = usuario;
        this.inicioPeriodo = inicioPeriodo;
        this.fimPeriodo = fimPeriodo;
    }
}